import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Mail, ArrowLeft } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Could not send reset link. Please try again.");
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#120021", display: "flex", alignItems: "center", justifyContent: "center", padding: "80px 16px 40px", position: "relative" }}>
      <div style={{ position: "fixed", inset: 0, pointerEvents: "none", zIndex: 0 }}>
        <div style={{ position: "absolute", width: "640px", height: "640px", background: "radial-gradient(circle, rgba(91,30,140,0.25), transparent)", top: "-120px", right: "-200px", borderRadius: "50%" }} />
      </div>

      <div className="glass-card animate-fadeInUp" style={{ maxWidth: "440px", width: "100%", padding: "32px", border: "1px solid rgba(255,209,102,0.2)", position: "relative", zIndex: 1 }}>
        <Link to="/auth?tab=login" style={{ display: "inline-flex", alignItems: "center", gap: "6px", color: "rgba(255,255,255,0.5)", fontSize: "0.82rem", textDecoration: "none", marginBottom: "14px" }}>
          <ArrowLeft size={14} /> Back to login
        </Link>
        <h1 className="font-cinzel gradient-text-gold" style={{ fontSize: "1.6rem", marginBottom: "8px" }}>Forgot Password</h1>
        <p style={{ color: "rgba(255,255,255,0.55)", fontSize: "0.9rem", marginBottom: "22px" }}>
          Enter your email and we&apos;ll send you a secure link to reset your password. The link is valid for 30 minutes.
        </p>

        {sent ? (
          <div data-testid="forgot-sent" style={{ background: "rgba(34,197,94,0.1)", border: "1px solid rgba(34,197,94,0.25)", borderRadius: "12px", padding: "16px", color: "#86efac" }}>
            <strong>Check your inbox.</strong>
            <p style={{ color: "rgba(255,255,255,0.65)", fontSize: "0.86rem", marginTop: "6px", lineHeight: 1.6 }}>
              If an account exists for <strong>{email}</strong>, a reset link has been sent. Check spam too if you don&apos;t see it.
            </p>
            <button onClick={() => navigate("/auth?tab=login")} className="btn-gold" style={{ marginTop: "16px", padding: "9px 22px", fontSize: "0.85rem" }}>Back to Login</button>
          </div>
        ) : (
          <form onSubmit={submit}>
            <label style={{ display: "block", color: "rgba(255,255,255,0.55)", fontSize: "0.78rem", marginBottom: "6px" }}>Email Address</label>
            <div style={{ position: "relative", marginBottom: "16px" }}>
              <Mail size={14} style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "rgba(255,255,255,0.4)" }} />
              <input data-testid="forgot-email-input" type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" className="cosmic-input" style={{ paddingLeft: "34px" }} />
            </div>
            {error && <div style={{ color: "#fca5a5", fontSize: "0.82rem", background: "rgba(239,68,68,0.1)", padding: "8px 12px", borderRadius: "8px", marginBottom: "14px" }}>{error}</div>}
            <button data-testid="forgot-submit-btn" type="submit" disabled={loading || !email} className="btn-gold" style={{ width: "100%", opacity: (loading || !email) ? 0.6 : 1 }}>
              {loading ? "Sending..." : "Send Reset Link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
